// The crossed-out eye of the hidden-teams button; also marks a hidden game.
export const EyeIcon = () => (
    <svg width="16" height="13" viewBox="0 0 13 10" fill="none" stroke="currentColor" strokeWidth="1.3" aria-hidden="true">
        <path d="M1 5c1.6-2.6 3.4-3.8 5.5-3.8S10.4 2.4 12 5c-1.6 2.6-3.4 3.8-5.5 3.8S2.6 7.6 1 5z" />
        <circle cx="6.5" cy="5" r="1.6" />
        <path d="M2 9.2 11 .8" />
    </svg>
);
